module.exports = __webpack_public_path__ + "static/media/note-4.07a56089.jpg";